import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideQuillConfig } from 'ngx-quill/config';
import { forbiddenErrorInterceptor } from '@interceptor/forbidden-error.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideAnimationsAsync(),
    provideAngularSvgIcon(),
    provideHttpClient(withInterceptors([forbiddenErrorInterceptor])),
    provideAnimationsAsync(),
    provideQuillConfig({
      modules: {},
    }),
  ],
};
